
export const SurveyStatisticCardMixin = {
  props: {
    colsLeft: {
      default: 7
    },
    colsRight: {
      default: 5
    }
  }
};
